import { useEffect } from 'react';
import PageLoadingFallback from '../components/common/PageLoadingFallback';

/**
 * Sends the browser to a URL outside the app, replacing the current history
 * entry so Back does not bounce the user here again. Keeps old in-app links and
 * bookmarks (e.g. /docs) working after a page moved to an external site.
 */
const ExternalRedirect = ({ to }) => {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return <PageLoadingFallback />;
};

export default ExternalRedirect;
